(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.delay = Number(this.dataset.interval) || 5000;
      this.querySelectorAll('[data-step]').forEach((button) => {
        button.addEventListener('click', () => {
          this.show(this.index + Number(button.dataset.step));
          this.restart();
        });
      });
      // Pause while the visitor reads or interacts with the bar.
      ['mouseenter', 'focusin'].forEach((type) => this.addEventListener(type, () => this.stop()));
      ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => this.start()));
      document.addEventListener('shopify:block:select', (event) => {
        const slide = this.slides.indexOf(event.target);
        if (slide < 0) return;
        this.stop();
        this.show(slide);
      });
      document.addEventListener('shopify:block:deselect', () => this.start());
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        const link = slide.querySelector('a');
        if (link) link.tabIndex = active ? 0 : -1;
      });
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.show(this.index + 1), this.delay);
    }

    stop() {
      clearInterval(this.timer);
    }

    restart() {
      if (!this.matches(':hover, :focus-within')) this.start();
    }
  }

  if (!customElements.get('announcement-rotator')) {
    customElements.define('announcement-rotator', AnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('select[data-autosubmit]');
    if (select && select.form) select.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tap-sound-video')) {
    /* Muted autoplay video: tap toggles sound, playback follows visibility. */
    class TapSoundVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-sound-toggle]');
        if (!this.video) return;
        this.video.muted = true;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
        }
        this.toggle?.addEventListener('click', () => this.setSound(this.video.muted));
        if (!('IntersectionObserver' in window) || reduce) return;
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
            this.setSound(false);
          }
        }, { threshold: [0, 0.4, 1] });
        this.observer.observe(this);
      }

      disconnectedCallback() { this.observer?.disconnect(); }

      setSound(on) {
        this.video.muted = !on;
        this.toggle?.setAttribute('aria-pressed', String(on));
        if (on && this.video.paused) this.video.play().catch(() => {});
      }
    }
    customElements.define('tap-sound-video', TapSoundVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        const load = async () => {
          this.dataset.loaded = 'true';
          try {
            const html = await (await fetch(this.dataset.url)).text();
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim()) {
              this.innerHTML = fresh.innerHTML;
              if (window.Theme && Theme.initReveal) Theme.initReveal(this);
            } else {
              this.closest('.shopify-section')?.setAttribute('hidden', '');
            }
          } catch (error) {
            /* recommendations are optional */
          }
        };
        if (!('IntersectionObserver' in window)) return load();
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load();
        }, { rootMargin: '0px 0px 400px 0px' });
        observer.observe(this);
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('results-carousel')) {
    /* Continuous drift (requestAnimationFrame) + prev/next steps.
       Cards are cloned once so the loop is seamless. */
    class ResultsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track || this.track.children.length < 2) return;
        Array.from(this.track.children).forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          this.track.appendChild(clone);
        });
        this.offset = 0;
        this.paused = false;
        this.speed = (Number(this.dataset.speed) || 3) * 0.15;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.step(-1));
        const viewport = this.querySelector('.results-gallery__viewport');
        viewport.addEventListener('mouseenter', () => (this.paused = true));
        viewport.addEventListener('mouseleave', () => (this.paused = false));
        viewport.addEventListener('touchstart', () => (this.paused = true), { passive: true });
        viewport.addEventListener('touchend', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));

        this.tick = this.tick.bind(this);
        if (!this.reduce) this.frame = requestAnimationFrame(this.tick);
      }

      disconnectedCallback() { cancelAnimationFrame(this.frame); }

      get half() { return this.track.scrollWidth / 2; }

      normalize() {
        const half = this.half;
        if (!half) return;
        if (this.offset <= -half) this.offset += half;
        if (this.offset > 0) this.offset -= half;
        this.track.style.transform = `translateX(${this.offset}px)`;
      }

      step(direction) {
        const card = this.track.children[0];
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.offset += direction * (card.offsetWidth + gap);
        this.track.style.transition = this.reduce ? 'none' : 'transform 0.4s ease';
        this.normalize();
        setTimeout(() => (this.track.style.transition = ''), 420);
      }

      tick() {
        if (!this.paused && !this.track.style.transition) {
          this.offset -= this.speed;
          this.normalize();
        }
        this.frame = requestAnimationFrame(this.tick);
      }
    }
    customElements.define('results-carousel', ResultsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    
  class ScrollToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => {
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
        const main = document.getElementById('MainContent');
        if (main) main.focus({ preventScroll: true });
      });
      this.onScroll = () => {
        const visible = window.scrollY > window.innerHeight;
        this.classList.toggle('is-visible', visible);
        this.button.tabIndex = visible ? 0 : -1;
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  if (!customElements.get('scroll-to-top')) customElements.define('scroll-to-top', ScrollToTop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-slider')) {
    class StorySlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.story-slider__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-go]'));
        this.index = 0;
        if (this.slides.length < 2) return;
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.go), true)));
        this.addEventListener('touchstart', (e) => (this.touchX = e.touches[0].clientX), { passive: true });
        this.addEventListener('touchend', (e) => {
          const delta = e.changedTouches[0].clientX - (this.touchX || 0);
          if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1), true);
        });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.stop());
        this.play();
      }

      disconnectedCallback() { this.stop(); }

      play() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay !== 'true' || reduce) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.interval) || 5000);
      }

      stop() { clearInterval(this.timer); }

      go(index, fromUser) {
        const count = this.slides.length;
        this.index = (index + count) % count;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.index);
          slide.setAttribute('aria-hidden', String(i !== this.index));
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.index);
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (fromUser) this.play();
      }
    }
    customElements.define('story-slider', StorySlider);

    document.addEventListener('shopify:block:select', (event) => {
      const slider = event.target.closest('story-slider');
      if (!slider) return;
      slider.stop();
      slider.go(slider.slides.indexOf(event.target));
    });
  }

  } catch(e) { console.error(e); }
})();
})();
